
import { ActivityFeed } from "@/components/dashboard/ActivityFeed";
import { DashboardMetrics } from "@/components/dashboard/DashboardMetrics";
import { PersonalInfoCard } from "@/components/dashboard/PersonalInfoCard";
import type { Client } from "@/types";

interface DashboardContentProps {
  profile: {
    full_name: string | null;
    email: string | null;
    phone: string | null;
    specialization: string | null;
    tier: string | null;
    avatar_url: string | null;
  };
  coachClients: Client[];
  timeFrame: 'week' | 'month' | 'year';
  onTimeFrameChange: (value: string) => void;
}

export function DashboardContent({ 
  profile, 
  coachClients, 
  timeFrame, 
  onTimeFrameChange 
}: DashboardContentProps) {
  return (
    <main className="p-6 space-y-6">
      <div>
        <h2 className="text-xl text-white/70">Welcome,</h2>
        <h1 className="text-3xl font-bold tracking-tight text-white">{profile.full_name}</h1>
      </div>

      <DashboardMetrics 
        coachClients={coachClients}
        timeFrame={timeFrame}
        onTimeFrameChange={onTimeFrameChange}
      />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <ActivityFeed className="col-span-1 lg:col-span-2" />
        <PersonalInfoCard profile={profile} />
      </div>
    </main>
  );
}
